import React from 'react';
import Icon from 'components/AppIcon';

const RateHistoryPanel = ({ history, isAdminOrPartner }) => {
  const formatDate = (dateStr) => {
    if (!dateStr) return '—';
    return new Date(dateStr)?.toLocaleDateString('en-KE', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  if (history?.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 bg-surface rounded-2xl border border-border">
        <div className="w-16 h-16 bg-secondary-50 rounded-2xl flex items-center justify-center mb-4">
          <Icon name="History" size={28} className="text-text-secondary" />
        </div>
        <p className="font-body-medium text-text-primary mb-1">No rate history</p>
        <p className="text-sm text-text-secondary">Rate changes will appear here for compliance tracking</p>
      </div>
    );
  }

  return (
    <div className="bg-surface rounded-2xl border border-border overflow-hidden">
      <div className="px-4 py-3 border-b border-border bg-secondary-50 flex items-center justify-between">
        <h3 className="text-sm font-body-semibold text-text-primary">Complete Rate Audit Trail</h3>
        <span className="text-xs text-text-secondary">{history?.length} records</span>
      </div>
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-border">
              {isAdminOrPartner && (
                <th className="text-left px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Lawyer</th>
              )}
              <th className="text-right px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Rate (KES/hr)</th>
              <th className="text-center px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Effective Date</th>
              <th className="text-center px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">End Date</th>
              <th className="text-center px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Status</th>
              <th className="text-left px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Notes</th>
              <th className="text-center px-4 py-3 text-xs font-body-semibold text-text-secondary uppercase tracking-wide">Created</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {history?.map((record, idx) => (
              <tr key={record?.id} className={`hover:bg-secondary-50 transition-colors ${idx === 0 ? 'bg-primary-50/30' : ''}`}>
                {isAdminOrPartner && (
                  <td className="px-4 py-3">
                    <p className="text-sm font-body-medium text-text-primary">{record?.user_profiles?.full_name || '—'}</p>
                    <p className="text-xs text-text-secondary">{record?.user_profiles?.email}</p>
                  </td>
                )}
                <td className="px-4 py-3 text-right">
                  <span className="text-sm font-body-semibold text-text-primary">
                    {Number(record?.base_hourly_rate)?.toLocaleString('en-KE')}
                  </span>
                  {idx === 0 && (
                    <span className="ml-2 text-xs bg-primary-50 text-primary px-1.5 py-0.5 rounded-full">Current</span>
                  )}
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="text-sm text-text-secondary">{formatDate(record?.effective_date)}</span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="text-sm text-text-secondary">{record?.end_date ? formatDate(record?.end_date) : 'Active'}</span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-body-medium ${
                    record?.approval_status === 'approved' ?'bg-success-50 text-success-700'
                      : record?.approval_status === 'pending' ?'bg-warning-50 text-warning-700' :'bg-error-50 text-error-700'
                  }`}>
                    {record?.approval_status?.charAt(0)?.toUpperCase() + record?.approval_status?.slice(1)}
                  </span>
                </td>
                <td className="px-4 py-3">
                  <span className="text-sm text-text-secondary">{record?.notes || '—'}</span>
                </td>
                <td className="px-4 py-3 text-center">
                  <span className="text-sm text-text-secondary">{formatDate(record?.created_at)}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RateHistoryPanel;
